import { GlobalSection } from '@betterfunnel/types';
import { collection, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../Firebase';
import { emptyConverter } from '../utils';

export const globalSectionsColRef = (accountId: string) => {
  return collection(db, 'accounts', accountId, 'globalSections').withConverter(
    emptyConverter<GlobalSection>(),
  );
};

export const globalSectionsQuery = (accountId: string) => {
  return query(
    globalSectionsColRef(accountId),
    where('status', '!=', 'deleted'),
  );
};

export const publishGlobalSection = async (
  accountId: string,
  globalSectionId: string,
): Promise<any> => {
  const fn = httpsCallable(
    functions,
    'accounts-globalSections-publishGlobalSection',
  );

  const res = await fn({
    accountId,
    globalSectionId,
  });

  return res.data;
};
